import React from "react";
import { NotFound } from "../pages/NotFound";

export default function ProtectedRoute(props) {
  const Component = props.component;
  const isAuthenticated = localStorage.getItem("token");

  return isAuthenticated ? <Component /> : <NotFound />;
}
